// extracted by mini-css-extract-plugin
export default {"draggableItem":"DraggableWrapper_draggableItem__quXn9","animation":"DraggableWrapper_animation__Qk1i6","image":"DraggableWrapper_image__S8tvm","text":"DraggableWrapper_text__EvFYB"};